import Icon from "../Icon";

/* ------------------------------ FORMULARIO ---------------------------- */

/**
 * Campo con su rótulo, su pista y su error.
 *
 * `grupo` cambia el `<label>` por un `<div role="group">`. Hace falta cuando
 * dentro no hay UN control sino varios, o botones: un `<button>` anidado en un
 * `<label>` es HTML ambiguo — el clic del rótulo se reenvía al control
 * asociado, y el navegador deja de calcular bien el nombre accesible del
 * botón. Se descubrió porque una prueba no encontraba el botón "Elegir
 * municipios" que estaba ahí, a la vista: lo que fallaba no era la prueba,
 * era el marcado.
 */
export function Field({ label, error, hint, children, span, grupo = false }) {
  const Envoltura = grupo ? "div" : "label";

  return (
    <Envoltura
      className="field"
      style={span ? { gridColumn: `span ${span}` } : undefined}
      {...(grupo && label ? { role: "group", "aria-label": label } : {})}
    >
      {label && <span className="label">{label}</span>}
      {children}
      {/* La ayuda tiene clase propia: antes reusaba `field-error` con `faint`
          encima, y como el color rojo gana por orden en la hoja, todas las
          pistas se leían como errores. */}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="field-error">{error}</span>}
    </Envoltura>
  );
}


/**
 * Ficha en modo lectura.
 *
 * Se usa `fieldset[disabled]`, que deshabilita TODOS los controles que
 * contiene: inputs, selects, textareas y botones, incluidos los que se
 * agreguen mañana. Ir campo por campo con `disabled` funcionaría hoy y se
 * rompería en el primer campo nuevo que alguien olvide marcar, y en un
 * formulario de treinta campos ese olvido no se ve.
 *
 * El pie del diálogo queda FUERA del fieldset a propósito: ahí vive el botón
 * de cerrar, que tiene que seguir respondiendo.
 */
export function CamposBloqueados({ activo, children }) {
  if (!activo) return children;
  return (
    <fieldset className="campos-bloqueados" disabled>
      {children}
    </fieldset>
  );
}


export function SearchInput({ value, onChange, placeholder = "Buscar…" }) {
  return (
    <div className="search">
      <Icon name="search" size={16} />
      <input
        className="input"
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}


export function Segmented({ value, onChange, options }) {
  return (
    <div className="segmented" role="group">
      {options.map((o) => (
        <button
          key={String(o.value)}
          type="button"
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
